import React from 'react';
import { Star, Users, TrendingUp, Award, CheckCircle } from 'lucide-react';

export const SocialProofBar = () => {
  return (
    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-y border-emerald-100 py-4">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm">
          {/* Trusted By */}
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5 text-emerald-600" />
            <span className="font-semibold text-gray-900">Trusted by 100+ Businesses</span>
          </div>
          
          {/* Star Rating */}
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={`star-${i}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-semibold text-gray-900">4.9/5</span>
            <span className="text-gray-600">(127 Reviews)</span>
          </div>
          
          {/* Success Rate */}
          <div className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-emerald-600" />
            <span className="font-semibold text-gray-900">₹50Cr+ Managed</span>
          </div>
          
          {/* Award */}
          <div className="flex items-center gap-2">
            <Award className="w-5 h-5 text-emerald-600" />
            <span className="font-semibold text-gray-900">CA Certified Team</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TrustBadges = () => {
  const badges = [
    { icon: CheckCircle, text: "100% Compliance Guarantee" },
    { icon: CheckCircle, text: "Dedicated CA Assigned" },
    { icon: CheckCircle, text: "24/7 Support" },
    { icon: CheckCircle, text: "Money-Back Guarantee" },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-4 mt-6">
      {badges.map((badge, index) => (
        <div key={stat.label || `stat-${index}`} className="flex items-center gap-2 bg-white/80 backdrop-blur px-4 py-2 rounded-full border border-emerald-200 shadow-sm">
          <badge.icon className="w-4 h-4 text-emerald-600" />
          <span className="text-sm font-medium text-gray-700">{badge.text}</span>
        </div>
      ))}
    </div>
  );
};
